export default __webpack_public_path__ + "static/media/anti-slip_prune.3bb7635f.webp";